<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPhoneHorisontal_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M2.603 18.46c-.397-1.42-.039-3.048.955-4.363 1.91-2.528 6.124-4.017 12.557-4.019 7.863 0 11.168 2.184 12.557 4.018.995 1.313 1.352 2.942.954 4.361a2.14 2.14 0 0 1-2.591 1.506l-4.61-1.152a2.15 2.15 0 0 1-1.63-2.087l-.024-1.645c-1.573-.374-3.078-.519-4.655-.517a24 24 0 0 0-4.606.44l-.073 1.733a2.14 2.14 0 0 1-1.629 2.078l-4.61 1.153a2.146 2.146 0 0 1-2.595-1.507"
    />
</svg>
